import { useRef, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Container,
  } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import DataTable from "../Core/DataTable";
import Notify from "../../lib/Utils/Alert";
import Spinner from 'react-bootstrap/Spinner';
import './ModalConfirm.css';

const ModalConfirm = ({ token,isOpen, toggle, onBack, onConfirm, termsShow, data = [],showColor,confirmLoader}) => {
  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }),[]);
  const tableRealTime = useRef(null);
  const tableNotRealTime = useRef(null);
  const supplierCtl = useMemo(() => new FileUpload(token), [token]);
  const headerReal = [
    { title: "Name", data: "name", sortable: true },
   
    {
      title: "Subtotal Face Value",
      data: "subtotal",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    },
    {
      title: "Subtotal",
      data: "total",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    }
  ];
  const headerNotReal = [
    { title: "Name", data: "name", sortable: true },
   
    {
      title: "Subtotal Face Value",
      data: "subtotal",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    },
    {
      title: "Subtotal",
      data: "total",
      sortable: true,
      render: data => data ? dollar.format(data) : 0,
    }
  ];
  const dataRealTime = data.filter((item) => item.edt === 0);
  const dataNotRealTime = data.filter((item) => item.edt > 0);

  useEffect(() => {
    if (tableRealTime.current) {
      tableRealTime.current.dataTable.clear().rows.add(dataRealTime).draw();
    }
    if (tableNotRealTime.current) {
      tableNotRealTime.current.dataTable.clear().rows.add(dataNotRealTime).draw();
    }
  }, [data]);
const downloadTermsandCondition = (url) => {
  const link = Object.assign(document.createElement('a'), { href: url, download: '', target: '_blank' });
  document.body.appendChild(link).click();
  document.body.removeChild(link);
};
const downloadFile = (FileType) => {
    supplierCtl.downloadPDFDocument(FileType,(data)=>{
        if(data && !data.error){
            downloadTermsandCondition(data?.link)
        }else{
            Notify(alert, "danger", data.error)
        }
})       
}
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop="static"
      centered={true}
      size="xl"
      style={{ maxWidth: "85% !important" }}
    >
      <ModalHeader className= {`${showColor === false || showColor === null || showColor === undefined ? "custom_header_colourTwo align-items-center " : " custom_header_colourTwo align-items-center"  } `}>
        <h5   style={{ 
          margin: 0, 
          fontSize: '20px', 
          ...(showColor ? { color: 'white' } : {})
       }}>Confirm order</h5>
      </ModalHeader>
      <ModalBody className="m-5">
        <Row>
          <Col xs="12">
            <h2 className="text-center mb-3"><span className="pb-1" style={{ borderBottom:'2px solid black'}}>Check your order</span></h2>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <Container>
              <h4>Real time orders</h4>
                <DataTable
                  className="mb-0 no-bottom-radius j_add_order_table"
                  options={{
                    dom: "t", 
                    responsive: true, 
                    scrollY: '20vh',
                    pageLength: -1,
                  }}
                  ref={tableRealTime}
                  columns={headerReal}
                  data={dataRealTime}
                  enableSelectFilters={true}
                />
            </Container>
          </Col>
        </Row>
        <Row>
          <Col xs="12" className="mt-4">
          <Container style={{ marginTop: "20px" }}>
              <h4>Non-Real time orders</h4>
                <DataTable
                  className="mb-0 no-bottom-radius j_add_order_table"
                  options={{
                    dom: "t", 
                    responsive: true,
                    scrollY: '20vh',
                    pageLength: -1,
                  }}
                  ref={tableNotRealTime}
                  columns={headerNotReal}
                  data={dataNotRealTime}
                  enableSelectFilters={true}
              />
            </Container>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter  className="modalFooter">
        {termsShow === false || termsShow === undefined ? 
        <>
      <div className="termsAndConditions">
        By clicking Confirm, you accept the 
        <div className="linkContainer">
          <Link to={"terms"} target="_blank" onClick={(e) => { e.preventDefault(); downloadFile('TERMS') }}> Terms of Use </Link>and 
          <Link to={"privacy"} target="_blank" onClick={(e) => { e.preventDefault(); downloadFile('PRIVACY') }}> Privacy Policy</Link>
        </div>
      </div>
      </>
      :""}
      <div className="buttons">
        <Button color="secondary" onClick={onBack}>
          Back
        </Button>
        <Button  className= "btn btn-primaryTwo " onClick={onConfirm} disabled={confirmLoader}>
          {!confirmLoader &&"Confirm"}
          {
            confirmLoader && 
            <Spinner
                               as="span"
                               animation="border"
                               size="sm"
                               role="status"
                               aria-hidden="true"
                               style={{
                                 margin: "0px 8px"
                               }}
                             />
          }
        </Button>
      </div>
     
    </ModalFooter>
    </Modal>
  );
};

export default ModalConfirm;
